/**
 * 匠人来源 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const tradesmansorce = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list (params) {
        return axios.get(api + 'tradesman/sorcelist', { params: params })
    },
    create (params) {
        return axios.post(api + 'tradesman/sorcecreate', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'tradesman/sorcedetail', { params: params })
    },
    remove (params) {
        return axios.post(api + 'tradesman/sorceremove', qs.stringify(params))
    },
    edit (params) {
        return axios.post(api + 'tradesman/sorceedit', qs.stringify(params))
    }
}

// 导出接口
export default tradesmansorce
